// Polyfill for packages expecting Node `global` in the browser
(globalThis as unknown as { global: typeof globalThis }).global = globalThis;

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureCognito } from '@consentropy/shared'
import App from './App';
import { AppThemeProvider } from '@consentropy/shared';

configureCognito();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppThemeProvider>
      <App />
    </AppThemeProvider>
  </StrictMode>,
);
